import React from 'react'
import { useAsyncDebounce } from 'react-table'
import { useInternationalization } from '../../features/i18n'

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length
  const [value, setValue] = React.useState(globalFilter)
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
  }, 200)
  const { translate } = useInternationalization()

  return (
    <div className="p-4 my-4 rounded text-xs" style={{border: '1px solid #ddd'}}>
      {translate('SEARCH', 'search')}:{' '}
      <input
        value={value || ""}
        onChange={e => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={`${count} items...`}
      />
    </div>
  )
}

export default GlobalFilter
